import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  List, ListItem, ListItemIcon, ListItemText, ListSubheader,
  Checkbox, DialogActions, Grid, Dialog, DialogContent
} from '@material-ui/core';
import { FormControl, TextField } from '@material-ui/core';
import { obtenerPermisosValor } from "../../global/js/funciones";
import AppBarModal from '../general/AppBarModal'
import { BtnForm } from "../general/BotonesAccion";
import TareasTerminadas from "../general/TareasTerminadas";
import emma_w from './../../global/imagenes/emma_w.png';

function RenderEstados({ estados_siguiente, estado, cambiarSeleccion }) {
  return (
    <List subheader={
      <ListSubheader component="div" >
        Seleccione Estado
      </ListSubheader>
    }>
      {estados_siguiente.map(({ secundario }) => {
        let { codigo, nombre } = secundario;
        return (
          <ListItem key={codigo} role={undefined} dense button onClick={() => cambiarSeleccion(codigo)} >
            <ListItemIcon>
              <Checkbox edge="start" checked={estado === codigo} tabIndex={-1} disableRipple />
            </ListItemIcon>
            <ListItemText id={codigo} primary={nombre} />
          </ListItem>
        );
      })}
    </List>
  );
}

class AcompanamientoDocenteGestionar extends Component {
  constructor(props) {
    super(props)
    this.state = {
      cargando: true,
      titulo_res: 'Cargando..',
      estado: '',
      observacion: '',
      estados_siguiente: []
    }
  }

  async componentDidUpdate({ modalGestionarAcompanamiento }) {
    let { modalGestionarAcompanamiento: modalGestionarAcompanamientoNew, proceso } = this.props;
    if (modalGestionarAcompanamiento !== modalGestionarAcompanamientoNew) {
      let estados_siguiente = proceso.estado_actual ? await obtenerPermisosValor(proceso.estado_actual.id) : []
      this.setState({ estado: '', observacion: '', estados_siguiente, cargando: false });
    }
  }

  reiniciarEstado() {
    this.setState({
      cargando: true,
      titulo_res: 'Cargando..',
      estado: '',
      observacion: ''
    })
  }

  onChange = ({ target }) => {
    let { value, name } = target;
    this.setState({
      [name]: value
    })
  }

  enviarDatos = async (e) => {
    let { actualizarMensaje } = this.props;
    let { estado, observacion } = this.state;
    let error = false

    if (estado === '') {
      error = true
      actualizarMensaje({ titulo: `Debe seleccionar un estado.`, tipo: 'info', mostrar: true, tiempo: 6000 })
    }

    if (observacion === '') {
      error = true
      actualizarMensaje({ titulo: `Debe especificar una observación.`, tipo: 'info', mostrar: true, tiempo: 6000 })
    }

    if (!error) this.onSubmit()
  }

  onSubmit = () => {
    let { proceso } = this.props;
    let { estado, observacion } = this.state;
    this.setState({ cargando: true, titulo_res: 'Enviando..' })
    let data = { estado, observacion, archivos: [], total: 0 }
    this.props.gestionarConsultoria(proceso.id, data, () => this.setState({ cargando: false, titulo_res: 'Cargando..' }));
    this.reiniciarEstado()
  }

  pintarEstados() {
    let { estado, estados_siguiente } = this.state;
    return (
      <Grid container>
        <Grid item xs={12} xl={12} sm={12} md={12} lg={12}>
          <RenderEstados cambiarSeleccion={(estado) => this.setState({ estado })} estado={estado} estados_siguiente={estados_siguiente} />
        </Grid>
        <Grid item xs={12}>
          <TextField
            type="text"
            id="observacion"
            name="observacion"
            label="Escriba las Observaciones"
            multiline
            fullWidth
            rows={4}
            onChange={this.onChange}
          />
        </Grid>
      </Grid>
    )
  }

  render() {
    let { modalGestionarAcompanamiento, mostrarModalGestionarAcompanamiento } = this.props;
    let { cargando, titulo_res } = this.state;

    return (
      <Dialog fullWidth={true} maxWidth="sm" open={modalGestionarAcompanamiento} onClose={mostrarModalGestionarAcompanamiento.bind(this, false)} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
        <AppBarModal titulo={'¿ Gestionar Acompañamiento Docente ?'} mostrarModal={mostrarModalGestionarAcompanamiento} titulo_accion="" accion="" />
        <DialogContent style={{ padding: '1' }} className='scroll'>
          {cargando ? <TareasTerminadas mensaje={titulo_res} marginTop='7%' imagen={emma_w} widthImg="7%" cargando={true} /> : <div style={{ padding: "5px 0 5px 0" }}> {this.pintarEstados()} </div>}
        </DialogContent>
        <DialogActions>
          <BtnForm texto="CANCELAR" callback={() => mostrarModalGestionarAcompanamiento(false)} />
          {!cargando && <BtnForm texto="ACEPTAR" callback={this.enviarDatos} />}
        </DialogActions>
      </Dialog>
    );
  }
}

AcompanamientoDocenteGestionar.propTypes = {
  modalGestionarAcompanamiento: PropTypes.bool.isRequired,
  mostrarModalGestionarAcompanamiento: PropTypes.func.isRequired,
}

export default AcompanamientoDocenteGestionar;